import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Heading } from "@chakra-ui/react";
import { Highlight } from "~/components";
import ImageAsset from "~/images/yellow-hands-sm.jpg";

export const Title: FC = () => {
  const { t } = useTranslation();

  return (
    <Flex
      align="center"
      bgImg={{ base: ImageAsset, md: "none" }}
      bgPos="center"
      bgRepeat="no-repeat"
      bgSize="cover"
      direction="column"
      gap={2}
      justify="center"
      minH={{ base: "10.25rem", md: "unset" }}
      position="relative"
      w="full"
    >
      <Heading maxW="30rem" variant="th-h6">
        {t("onboarding.someLogisticsPage.qualifier")}
      </Heading>
      <Heading textAlign="center" variant="th-h3">
        <Highlight highlightColor="var(--chakra-colors-newReddish-50)">
          {t("onboarding.someLogisticsPage.heading")}
        </Highlight>
      </Heading>
    </Flex>
  );
};
